
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Golden Black
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              Leading innovation-driven chemical solutions provider for the oil and gas industry. 
              Our expert engineers design and produce custom products for diverse fields including food-grade applications, 
              cosmetics, water treatment, and industrial processes, delivering advanced sustainable formulations.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Upstream Solutions</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Corrosion Mitigation</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Custom Formulations</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">R&D Services</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">
                <i className="ri-phone-line mr-2"></i>
                +971562761272
              </li>
              <li className="text-gray-300">
                <i className="ri-mail-line mr-2"></i>
                info@chemsolutionservice.live
              </li>
              <li className="text-gray-300">
                <i className="ri-map-pin-line mr-2"></i>
                Abu Dhabi, UAE
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Golden Black. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
